import React, { useEffect }from "react";

import "./ServiceCard.css";
import AOS from 'aos'

const ServiceCard = (props) => {
    const { animation = "fade-right", icon, title, text } = props;
    useEffect(() => {
        AOS.init({
          duration: 1000
        })
      }, [])
    return (
    <div data-aos={animation} data-aos-once="true" className="card-service h-100 d-flex flex-row align-items-center p-3">
      {icon}
      <div className="card-container">
        <h5 className="card-title text-success">{title}</h5>
        <p className="card-text">{text}</p>
      </div>
    </div>
    )
}

export default ServiceCard;